import { render, staticRenderFns } from "./EscalaVenda.vue?vue&type=template&id=347e2516&"
import script from "./EscalaVenda.vue?vue&type=script&lang=js&"
export * from "./EscalaVenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports